import { render, staticRenderFns } from "./TextMedium.vue?vue&type=template&id=b7c6b2fa&scoped=true&"
import script from "./TextMedium.vue?vue&type=script&lang=ts&"
export * from "./TextMedium.vue?vue&type=script&lang=ts&"
import style0 from "./TextMedium.vue?vue&type=style&index=0&id=b7c6b2fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7c6b2fa",
  null
  
)

export default component.exports